import { render } from "./input-switch.vue?vue&type=template&id=7e91264c"
import script from "./input-switch.vue?vue&type=script&lang=js"
export * from "./input-switch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__